module.exports = __webpack_public_path__ + "media/images/pattern-8b3785c4c493049254c5ee374a80ea68.svg";